import mapLocale, { getLang } from '../I18N';
import React from 'react';
import ReactDOM from 'react-dom';
import { message } from "tntd";
import ReferenceBatchCheck from './ReferenceBatchCheck';
import './index.less';




export default (props) => {
  const { rq } = props || {};

  const appendModal = (reject, resolve, referenceData = []) => {
    let type = '';
    if (!Array.isArray(referenceData) && referenceData?.type) {
      type = referenceData?.type;
      referenceData = referenceData?.result || [];
    }

    const modalWrap = document.createElement('div');
    modalWrap.setAttribute('id', 'tddc-reference-online-check-modal');

    const removeModal = () => {
      const tddcModal = document.querySelectorAll('#tddc-reference-online-check-modal');
      if (tddcModal) {
        tddcModal.forEach((ele) => ele?.parentNode?.removeChild(ele));
      }
      modalWrap && modalWrap?.parentNode?.removeChild(modalWrap);

      !type && reject && reject(referenceData);
      
      if (document.body.getAttribute('style')) {
        document.body.removeAttribute('style');
      }
    };

    removeModal();

    document.body.appendChild(modalWrap);

    // 能进行下一步操作
    const canNextOpera = !!type && !['STRONG'].includes(type);

    ReactDOM.render(
     <ReferenceBatchCheck {...props} referenceData={referenceData} type={type}  modalWrap={modalWrap} canNextOpera={canNextOpera} resolve={resolve} removeModal={removeModal}/>,
      modalWrap,
    );
  };

  if (rq && typeof rq === 'function') {
    const I18N = mapLocale[getLang()];
    return new Promise((resolve, reject) => {
      return rq().then((res) => {
        const { success, data } = res || {};
        if (success) {
          if (Array.isArray(data) && !!data?.length) {
            appendModal(reject, resolve, data);
          } else if (!Array.isArray(data) && data?.type !== 'NO_EXIST') {
            appendModal(reject, resolve, data);
          } else {
            resolve(data);
          }
        } else {
          reject(I18N.referencebatchcheck.index.chaXunGuanLianGuan);
        }
      });
    });
  } else {
    message.error(I18N.referencebatchcheck.index.qingTiGongYiGe);
  }
};
